module.exports = __webpack_public_path__ + "img/ic-user.8881eee1.svg";